<app-main-menu></app-main-menu>
<div style="margin-top: 12vh;" class="container">
    <div class="row justify-content-center">
        <div class="col-lg-4 text-center">
           <img src="../../../assets/img/medicinegeneral.jpg" alt="" width="200px">
           <h3 class="mb-2">Medicina general</h3>    
           <p>Consulta aqui cualquier duda sobre salud</p>
           <p (click)="handleOpc(); opc1 = true">Iniciar Consulta</p> 
        </div>
        <div class="col-lg-4 text-center">
            <img src="../../../assets/img/salud-mental.jpg" alt="" width="200px">
            <h3 class="mb-2">Salud mental</h3>    
            <p>Quieres conversar ? Recomendaciones</p>
            <p (click)="handleOpc(); opc2 = true">Iniciar Consulta</p> 
        </div>
        <div class="col-lg-4 text-center">
            <img src="../../../assets/img/odontologia.jpg" alt="" width="200px">
            <h3 class="mb-2">Odontología</h3>    
            <p>Muestranos tu sonrisa</p>
            <p (click)="handleOpc(); opc3 = true">Iniciar Consulta</p> 
        </div>
        <div class="col-lg-4 text-center">
            <img src="../../../assets/img/nutricion.jpg" alt="" width="200px">
            <h3 class="mb-2">Nutrición</h3>    
            <p>¿Como te cuidas?</p>
            <p (click)="handleOpc(); opc4 = true">Iniciar Consulta</p> 
        </div>
        <div class="col-lg-4 text-center">
            <img src="../../../assets/img/saludsexual.jpg" alt="" width="200px">
            <h3 class="mb-2">Salud Sexual</h3>    
            <p>Cuídate</p>
            <p (click)="handleOpc(); opc5 = true">Iniciar Consulta</p> 
        </div>
    </div>

    <div *ngIf="opc1 || opc2 || opc3 || opc4 || opc5">
        <h2>¿Con quién quieres consultar?</h2>
        <div *ngIf="opc1" class="row justify-content-center">
            <div *ngFor="let doc of doctorsType0; let i = index" class="col-lg-4 text-center">
                <div>
                    <img src="https://randomuser.me/api/portraits/men/{{i}}.jpg" class="image rounded-circle" alt="">
                    <p>{{doc.name}} {{doc.lastname}}</p>
                    <p (click)="chatWithDoctor(doc.uid)">Empieza a hablar</p>
                </div>
            </div>
        </div>
        <div *ngIf="opc2" class="row justify-content-center">
            <div *ngFor="let doc of doctorsType1; let i = index" class="col-lg-4 text-center">
                <div>
                    <img src="https://randomuser.me/api/portraits/women/{{i}}.jpg" class="image rounded-circle" alt="">
                    <p>{{doc.name}} {{doc.lastname}}</p>
                    <p (click)="chatWithDoctor(doc.uid)">Empieza a hablar</p>
                </div>
            </div>
        </div>
        <div *ngIf="opc3" class="row justify-content-center">
            <div *ngFor="let doc of doctorsType4; let i = index" class="col-lg-4 text-center">
                <div>
                    <img src="https://randomuser.me/api/portraits/women/{{i}}.jpg" class="image rounded-circle" alt="">
                    <p>{{doc.name}} {{doc.lastname}}</p>
                    <p (click)="chatWithDoctor(doc.uid)">Empieza a hablar</p>
                </div>
            </div>
        </div>
        <div *ngIf="opc4" class="row justify-content-center">
            <div *ngFor="let doc of doctorsType2; let i = index" class="col-lg-4 text-center">
                <div>
                    <img src="https://randomuser.me/api/portraits/women/{{i}}.jpg" class="image rounded-circle" alt="">
                    <p>{{doc.name}} {{doc.lastname}}</p>
                    <p (click)="chatWithDoctor(doc.uid)">Empieza a hablar</p>
                </div>
            </div>
        </div>
        <div *ngIf="opc5" class="row justify-content-center">
            <div *ngFor="let doc of doctorsType3; let i = index" class="col-lg-4 text-center">
                <div>
                    <img src="https://randomuser.me/api/portraits/men/{{i}}.jpg" class="image rounded-circle" alt="">
                    <p>{{doc.name}} {{doc.lastname}}</p>
                    <p (click)="chatWithDoctor(doc.uid)">Empieza a hablar</p>
                </div>
            </div>
        </div>
    </div>
</div>